// Universal redirect preservation through authentication flow.
// Routes that should NOT be preserved (login/auth pages)
const excludedPaths = [
  '/login',
  '/login/azure',
  '/sso',
  '/logout',
  '/reset-password',
  '/forgot-password',
];

export function shouldPreserveRedirect(path) {
  if (!path || typeof path !== 'string') {
    return false;
  }

  // Exclude login/auth pages to prevent redirect loops
  return !excludedPaths.some(excluded => path.startsWith(excluded));
}

export function shouldCaptureIntendedUrl(path) {
  if (!path || typeof path !== 'string') {
    return false;
  }
  return shouldPreserveRedirect(path);
}
